import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import style from '../../../style/components/profile/emails/EmailCollisionAlert.module.scss';

// AXP-1613: shown after OTP verification succeeds but the address turns out
// to already be associated with another wallet — collisions are only
// revealed post-verification, never before the member proves possession.
const EmailCollisionAlert = ({ address, onTryDifferent }) => {
  const { t } = useTranslation();

  return (
    <div className={style.alertContainer}>
      <div className={style.alertContent}>
        <div className={style.iconContainer}>
          <idme-icon name="alert-circle" size="small" />
        </div>
        <div className={style.textContainer}>
          <div className={style.messageBlock}>
            <h3 className={style.alertTitle}>
              {t('walletEmails.collisionTitle')}
            </h3>
            <p className={style.alertBody}>
              {t('walletEmails.collisionBody', { email: address })}
            </p>
          </div>
          <div className={style.actionGroup}>
            <button
              type="button"
              className={style.textLink}
              onClick={onTryDifferent}
            >
              {t('walletEmails.collisionTryDifferent')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

EmailCollisionAlert.propTypes = {
  address: PropTypes.string.isRequired,
  onTryDifferent: PropTypes.func.isRequired,
};

export default memo(EmailCollisionAlert);
